<template>
  <div>
    <el-menu
      default-active="6" mode="horizontal">

      <el-menu-item index="1" v-if="isLoggedIn" @click="$router.push('/')">
        <i class="el-icon-user"></i>
        Profil
      </el-menu-item>

      <el-menu-item index="2" v-if="isLoggedIn" @click="$router.push('/dashboard')">
        <i class="el-icon-s-marketing"></i>
        Dashboard
      </el-menu-item>

      <el-menu-item index="3" v-if="isAdmin" @click="$router.push('/admin')">
        <i class="el-icon-menu"></i>
        Admin
      </el-menu-item>

      <el-menu-item index="4" v-if="isAdmin" @click="$router.push('/komisen')">
        <i class="el-icon-menu"></i>
        Komisyen
      </el-menu-item>

      <el-menu-item index="5" v-if="isLoggedIn" @click="logout">
        <font-awesome-icon :icon="['fa', 'sign-out-alt']" size="lg" :style="{color:  '#010101'}"></font-awesome-icon>
        Logout
      </el-menu-item>

      <el-menu-item index="6" v-if="!isLoggedIn" @click="$router.push('/register')">
        <i class="el-icon-thumb"></i>
        Daftar
      </el-menu-item>

      <el-menu-item index="7" v-if="!isLoggedIn" @click="$router.push('/login')">
        <font-awesome-icon :icon="['fa', 'sign-in-alt']" size="lg" :style="{color: '#010101'}"></font-awesome-icon>
        Login
      </el-menu-item>

    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
      isAdmin : function(){ return this.$store.getters.isAdmin}
    },
    methods: {
      async logout (){
        await this.$store.dispatch('LogOut')
        this.$router.push('/login')
      }
    },
}
</script>
<style>
a {
  text-decoration: none;
}

.el-menu-itam {
  padding: 0 15px;
}
</style>
